export function storeGet(key: string) {
  const value = localStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (e) {
    if (e instanceof SyntaxError) {
      return value;
    }
    throw e;
  }
}

export function storeSet(key: string, value: unknown) {
  const storageValue = typeof value === 'string' ? value : JSON.stringify(value);
  localStorage.setItem(key, storageValue);
  return true;
}

function useStorage() : { get: (key: string) => string | number | boolean | object, set: (key: string, value: unknown) => boolean } {
  return {
    get: (key) => storeGet(key),
    set: (key, value) => storeSet(key, value),
  };
}

export default useStorage;
